<template>
    <div class="datenschutz">
        <Headline/>
        <BackButton/>
        <h3 class="label">Datenschutz</h3>
        <div class="text">
            <p class="speechBubble-right halfWidth">
                Hallo, wie schaut's denn bei euch mit'm Datenschutz aus?
            </p>
            <br><br>
            <div class="speechBubble-left fullWidth">
                <p>Wir haben diese Datenschutzerklärung (Fassung 23.11.2018-211079994) verfasst, um Ihnen gemäß der
                    Vorgaben
                    der
                    Datenschutz-Grundverordnung (EU) 2016/679 und dem <a
                                                                         href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&amp;Gesetzesnummer=10001597&amp;tid=211079994"
                                                                         target="_blank" rel="noopener nofollow"
                                                                        >Datenschutzgesetz (DSG)</a> zu
                    erklären, welche Informationen wir sammeln, wie wir Daten verwenden und welche
                    Entscheidungsmöglichkeiten
                    Sie als Besucher dieser Webseite haben.</p>
                <p>Leider liegt es in der Natur der Sache, dass diese Erklärungen sehr technisch klingen, wir haben uns
                    bei der Erstellung jedoch bemüht die wichtigsten Dinge so einfach und klar wie möglich zu
                    beschreiben.</p>
                <h2>Automatische Datenspeicherung</h2>
                <p>Wenn Sie heutzutage Webseiten besuchen, werden gewisse Informationen automatisch erstellt und
                    gespeichert, so auch auf dieser Webseite.</p>
                <p>Wenn Sie unsere Webseite so wie jetzt gerade besuchen, speichert unser Webserver (Computer auf dem
                    diese Webseite gespeichert ist) automatisch Daten wie</p>
                <ul>
                    <li>die Adresse (URL) der aufgerufenen Webseite</li>
                    <li>Browser und Browserversion</li>
                    <li>das verwendete Betriebssystem</li>
                    <li>die Adresse (URL) der zuvor besuchten Seite (Referrer URL)</li>
                    <li>den Hostname und die IP-Adresse des Geräts von welchem aus
                        zugegriffen wird
                    </li>
                    <li>Datum und Uhrzeit</li>
                </ul>
                <p>in Dateien (Webserver-Logfiles).</p>
                <p>In der Regel werden Webserver-Logfiles zwei Wochen gespeichert und danach automatisch gelöscht. Wir
                    geben diese Daten nicht weiter, können jedoch nicht ausschließen, dass diese Daten beim Vorliegen
                    von rechtswidrigem Verhalten eingesehen werden.<br/>
                    Die Rechtsgrundlage besteht nach <a
                                                        href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=211079994"
                                                        target="_blank" rel="noopener nofollow">Artikel
                        6  Absatz 1 f DSGVO</a> (Rechtmäßigkeit der Verarbeitung) darin, dass berechtigtes Interesse
                    daran besteht, den fehlerfreien Betrieb dieser Webseite durch das Erfassen von Webserver-Logfiles zu
                    ermöglichen.</p>
                <h2>Speicherung persönlicher Daten</h2>
                <p>Persönliche Daten, die Sie uns auf dieser Website elektronisch übermitteln, wie zum Beispiel Name,
                    E-Mail-Adresse, Adresse oder andere persönlichen Angaben im Rahmen der Übermittlung eines Formulars
                    oder Kommentaren im Blog, werden von uns gemeinsam mit dem Zeitpunkt und der IP-Adresse nur zum
                    jeweils angegebenen Zweck verwendet, sicher verwahrt und nicht an Dritte weitergegeben.</p>
                <p>Wir nutzen Ihre persönlichen Daten somit nur für die Kommunikation mit jenen Besuchern, die Kontakt
                    ausdrücklich wünschen und für die Abwicklung der auf dieser Webseite angebotenen Dienstleistungen
                    und Produkte. Wir geben Ihre persönlichen Daten ohne Zustimmung nicht weiter, können jedoch nicht
                    ausschließen, dass diese Daten beim Vorliegen von rechtswidrigem Verhalten eingesehen werden.</p>
                <p>Wenn Sie uns persönliche Daten per E-Mail schicken &#8211; somit abseits dieser Webseite &#8211;
                    können wir keine sichere Übertragung und den Schutz Ihrer Daten garantieren. Wir empfehlen Ihnen,
                    vertrauliche Daten niemals unverschlüsselt per E-Mail zu übermitteln.</p>
                <p>Die Rechtsgrundlage besteht nach <a
                                                       href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&amp;tid=211079994"
                                                       target="_blank" rel="noopener nofollow">Artikel
                    6  Absatz 1 a DSGVO</a> (Rechtmäßigkeit der Verarbeitung) darin, dass Sie uns die Einwilligung zur
                    Verarbeitung der von Ihnen eingegebenen Daten geben. Sie können diesen Einwilligung jederzeit
                    widerrufen &#8211; eine formlose E-Mail reicht aus, Sie finden unsere Kontaktdaten im Impressum.</p>
                <h2>Rechte laut Datenschutzgrundverordnung</h2>
                <p>Ihnen stehen laut den Bestimmungen der DSGVO und des österreichischen <a
                                                                                            href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&amp;Gesetzesnummer=10001597&amp;tid=211079994"
                                                                                            target="_blank"
                                                                                            rel="noopener nofollow"
                                                                                           >Datenschutzgesetzes
                    (DSG)</a> grundsätzlich die folgende Rechte zu:</p>
                <ul>
                    <li>Recht auf Berichtung (Artikel 16 DSGVO)</li>
                    <li>Recht auf Löschung („Recht auf Vergessenwerden“) (Artikel 17 DSGVO)
                    </li>
                    <li>Recht auf Einschränkung der Verarbeitung (Artikel 18 DSGVO)</li>
                    <li>Recht auf Benachrichtigung &#8211; Mitteilungspflicht im Zusammenhang
                        mit der Berichtigung oder Löschung personenbezogener Daten oder der Einschränkung der
                        Verarbeitung (Artikel 19 DSGVO)
                    </li>
                    <li>Recht auf Datenübertragbarkeit (Artikel 20 DSGVO)</li>
                    <li>Widerspruchsrecht (Artikel 21 DSGVO)</li>
                    <li>Recht, nicht einer ausschließlich auf einer automatisierten
                        Verarbeitung — einschließlich Profiling — beruhenden Entscheidung unterworfen zu werden (Artikel
                        22 DSGVO)
                    </li>
                </ul>
                <p>Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre
                    datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der
                    Aufsichtsbehörde beschweren, welche in Österreich die Datenschutzbehörde ist, deren Webseite Sie
                    unter <a href="https://www.dsb.gv.at/?tid=211079994"
                             rel="nofollow">https://www.dsb.gv.at/</a> finden.</p>
                <h2>TLS-Verschlüsselung mit https</h2>
                <p>Wir verwenden https um Daten abhörsicher im Internet zu übertragen (Datenschutz durch
                    Technikgestaltung <a
                                         href="https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679&amp;from=DE&#038;tid=211079994"
                                         target="_blank" rel="noopener nofollow">Artikel 25 Absatz 1
                        DSGVO</a>). Durch den Einsatz von TLS (Transport Layer Security), einem
                    Verschlüsselungsprotokoll zur sicheren Datenübertragung im Internet können wir den Schutz
                    vertraulicher Daten sicherstellen. Sie erkennen die Benutzung dieser Absicherung der
                    Datenübertragung am kleinen Schloßsymbol links oben im Browser und der Verwendung des Schemas https
                    (anstatt http) als Teil unserer Internetadresse.</p>
                <h2>Google Fonts Datenschutzerklärung</h2>
                <p>Wir verwenden Google Fonts der Firma Google Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043,
                    USA) auf unserer Webseite. Die Verwendung von Google Fonts erfolgt ohne Authentisierung und es
                    werden keine Cookies and die Google Fonts API gesendet. Sollten Sie ein Konto bei Google haben,
                    werden keine Ihrer Google-Kontodaten an Google während der Nutzung von Google Fonts übermittelt.
                    Google erfasst lediglich die Nutzung von CSS und der verwendeten Fonts und speichert diese Daten
                    sicher. Mehr zu diesen und weiteren Fragen finden Sie auf <a
                                                                                 href="https://developers.google.com/fonts/faq"
                                                                                 rel="nofollow">https://developers.google.com/fonts/faq?tid=211079994</a>.
                </p>
                <p>Welche Daten von Google erfasst werden und wofür diese Daten verwendet werden, können Sie auf <a
                        href="https://www.google.com/intl/de/policies/privacy/"
                        rel="nofollow">https://www.google.com/intl/de/policies/privacy/</a> nachlesen.
                </p>
                <h2>Google Analytics Datenschutzerklärung</h2>
                <p>Wir verwenden auf dieser Website Google Analytics der Firma Google LLC (1600 Amphitheatre Parkway
                    Mountain View, CA 94043, USA) um Besucherdaten statistisch auszuwerten.</p>
                <p>Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter <a
                        href="http://www.google.com/analytics/terms/de.html"
                        rel="nofollow">http://www.google.com/analytics/terms/de.html</a> bzw. unter <a
                        href="https://support.google.com/analytics/answer/6004245?hl=de"
                        rel="nofollow">https://support.google.com/analytics/answer/6004245?hl=de</a>.
                </p>
                <h3>Pseudonymisierung</h3>
                <p>Unser Anliegen im Sinne der DSGVO ist die Verbesserung unseres Angebotes und unseres Webauftritts. Da
                    uns die Privatsphäre unserer Nutzer wichtig ist, werden die Nutzerdaten pseudonymisiert. Die
                    Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6
                    EU-DSGVO Abs 1 lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.</p>
                <h3>Deaktivierung der Datenerfassung durch Google Analytics</h3>
                <p>Mithilfe des <strong>Browser-Add-ons zur Deaktivierung</strong> von Google
                    Analytics-JavaScript (ga.js, analytics.js, dc.js) können Website-Besucher verhindern, dass Google
                    Analytics ihre Daten verwendet.</p>
                <p>Sie können die Erfassung der durch Ihre Nutzung der Website bezogenen
                    Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem
                    folgenden Link verfügbare Browser-Plugin herunterladen und installieren: <a
                            href="https://tools.google.com/dlpage/gaoptout?hl=de"
                            rel="nofollow">https://tools.google.com/dlpage/gaoptout?hl=de</a></p>
                <p>&nbsp;</p>
                <p style="margin-top:15px;">Quelle: Erstellt mit dem <a
                        title="Datenschutz Generator von firmenwebseiten.at"
                        href="https://www.firmenwebseiten.at/datenschutz-generator/" target="_blank" rel="follow"
                        style="text-decoration:none;">Datenschutz Generator von firmenwebseiten.at</a> in Kooperation
                    mit <a href="https://www.hausbaueninfo.at" target="_blank" rel="follow" title=""
                           style="text-decoration:none;">hausbaueninfo.at</a></p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import answers from "@/assets/answers";
    import Headline from "@/components/Headline";
    import BackButton from "@/components/BackButton";

    @Component({
        components: {BackButton, Headline},
    })
    export default class Datenschutz extends Vue {

    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/SpeechBubble.scss";

    .datenschutz {

        $titleFontSize: 40px;

        width: 90vw;
        max-width: 1000px;
        margin: 0 auto;

        .label {
            font-weight: 900;
            text-align: left;
            font-size: $titleFontSize;
            font-variant: small-caps;
        }

        .text {
            font-size: 20px;
            line-height: 30px;

            padding: 15px;

            * {
                display: inline-block;
                text-align: left;
            }
        }
    }
</style>
<style>

</style>
